var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasicIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6.88672C2.99823 6.60347 3.07366 6.32489 3.21777 6.08105L3.21875 6.07812C3.36177 5.8325 3.56624 5.6279 3.81152 5.48438L9.23926 2.38281C9.49038 2.24191 9.77355 2.16797 10.0615 2.16797C10.3495 2.16797 10.6327 2.24192 10.8838 2.38281L16.3076 5.48145V5.48242C16.4927 5.59064 16.6549 5.73277 16.7852 5.90137L16.9043 6.0791C17.0109 6.26442 17.0801 6.46813 17.1084 6.67871L17.123 6.8916V13.0967L17.1084 13.3115C17.0801 13.5246 17.0103 13.7306 16.9023 13.918V13.9199C16.7618 14.1657 16.5573 14.3692 16.3115 14.5098L10.8809 17.6133L10.8779 17.6152C10.63 17.7591 10.3481 17.835 10.0615 17.835C9.77494 17.835 9.49301 17.7591 9.24512 17.6152L9.24316 17.6133L3.81152 14.5098C3.56495 14.3661 3.36014 14.1604 3.21777 13.9131C3.07502 13.665 2.99992 13.3839 3 13.0977V6.88672Z",
    fill: "#23242A",
    stroke: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicIcon);
export default __webpack_public_path__ + "static/media/basic-icon.b6d640a82652f8224b7db07687e94a89.svg";
export { ForwardRef as ReactComponent };